import React from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import MuiList, { ListProps as MuiListProps } from '@material-ui/core/List';
import classnames from 'classnames';

const styles = ({
  custom: {
    palette: { colorSupportPowder },
  },
}: Theme) =>
  createStyles({
    includeBorder: {
      border: `1px solid ${colorSupportPowder}`,
    },
  });

export interface ListProps extends Omit<MuiListProps, 'classes'>, WithStyles<typeof styles> {
  includeBorder?: boolean;
}

const List: React.FC<ListProps> = ({ classes, className, includeBorder, ...rest }) => (
  <MuiList
    className={classnames(className, {
      [classes.includeBorder]: includeBorder,
    })}
    {...rest}
  />
);

export default withStyles(styles)(List);
